import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { IAppointmentData, IAppointmentStatusLogs } from 'src/app/models/IAppointmentDetails';
import { IAttributes } from 'src/app/models/IAttributes';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { Defaults } from 'src/app/Utilities/defaults';

@Component({
  selector: 'app-app-append-comments',
  templateUrl: './app-append-comments.component.html',
  styleUrls: ['./app-append-comments.component.css']
})
export class AppAppendCommentsComponent implements OnInit {

  commentForm: FormGroup;
  postComment: Array<IAppointmentStatusLogs> = [];
  postComment_Master: Array<IAppointmentStatusLogs> = [];
  appointmentLogs: any = [];
  submitted: boolean = true;
  public id = 0;
  appStatusList: IAttributes[] = [];
  selectedAppStatus: IAttributes;
  constructor(private formBuilder: FormBuilder,
    private schedulerservice: SchedularServiceService,
    private sharedService: SharedService,
    private _toasterService: ToastrService,
    private _datePipe: DatePipe,
    public dialogRef: MatDialogRef<AppAppendCommentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {


  }

  ngOnInit() {
    this.createForm();
    this.getAppointmentLogs();


  }

  getAppointmentLogService_Submit() {
    this.schedulerservice.GetAppointmentStatusLogs(this.data.apptData.Id).subscribe(result => {
      this.appointmentLogs = [];
      this.postComment_Master = [];
      if (result != null) {
        this.appointmentLogs = result.filter(i => i.appointmentId == this.data.apptData.Id);

        result.filter(i => i.comments != null && i.comments.length > 0 && i.appointmentId == this.data.apptData.Id)  // --- siva neeed to add
          .forEach(element => {
            this.postComment_Master.push({
              commentId: this.id++,
              currentDate: element.appDate,
              createdDate: this._datePipe.transform(element.createdDate, "MM/dd/yyyy hh:mm a").toString(),
              commentTxt: element.comments,
              providerName: element.providerName,
              appStatus: element.appStatus,
              displayComments: element.comments,
            });
          })
        this.postComment = this.postComment_Master.filter(i => i.appStatus == this.selectedAppStatus.attributeName);

      }
    });

  }
  getAppointmentLogs() {

    //  this. postComment= [];
    // this.postComment_Master= [];
    // this.appointmentLogs=[];
    this.appStatusList = [];
    this.selectedAppStatus = null;
    this.schedulerservice.GetAppointmentStatusLogs(this.data.apptData.Id).subscribe(result => {
      this.appointmentLogs = [];
      if (result != null) {
        this.appointmentLogs = result.filter(i => i.appointmentId == this.data.apptData.Id);

        result.filter(i => i.comments != null && i.comments.length > 0 && i.appointmentId == this.data.apptData.Id)  // --- siva neeed to add
          .forEach(element => {
            this.postComment_Master.push({
              commentId: this.id++,
              currentDate: element.appDate,
              //this._datePipe.transform(element.appDate,"MM/dd/yyyy hh:mm a").toString(),
              // new Date(element.appDate.replace(/-/gi,'/')),
              createdDate: this._datePipe.transform(element.createdDate, "MM/dd/yyyy hh:mm a").toString(),
              //element.createdDate.replace(/-/gi,'/'),
              commentTxt: element.comments,
              providerName: element.providerName,
              appStatus: element.appStatus,
              displayComments: element.comments,
            });


          })
        if (this.appointmentLogs.length > 0)
          this.getAppointmentStatusList();
      }
    })

  }
  getAppointmentStatusList() {
    this.sharedService.getAttributesById(Defaults.Appointment_type).subscribe(
      (app: IAttributes[]) => {

        this.appStatusList = app;
        this.appStatusList = this.appStatusList.filter(i => i.attributeName == "Confirmed" || i.attributeName == "Cancelled" || i.attributeName == "Rescheduled")
        let selectedAttribltes = "";
        if (this.appointmentLogs.length > 0)
          selectedAttribltes = "," + this.appointmentLogs.map((i: any) => i.appStatus.toLocaleLowerCase().trim()).join(",") + ",";
        this.appStatusList = this.appStatusList.filter(i => selectedAttribltes.indexOf("," + i.attributeName.toLocaleLowerCase().trim() + ",") > -1);
        if (this.appStatusList.length > 0) {
          var currentStatus = this.appStatusList.filter(i => i.attributeName == this.data.apptData.status);
          if (currentStatus && currentStatus.length > 0)
            this.selectedAppStatus = currentStatus[0];
          else
            this.selectedAppStatus = this.appStatusList[0];

          this.fnShowSelectedComments();
        }
      },
      (err: any) => console.log(err));

  }
  fnShowSelectedComments() {
    this.postComment = this.postComment_Master.filter(i => i.appStatus == this.selectedAppStatus.attributeName);
    if (this.selectedAppStatus.attributeName.toUpperCase() == "CONFIRMED") {
      this.commentForm.controls["titleA"].setValue("Confirmed via Phone");
      this.commentForm.controls["titleB"].setValue("Confirmed via SMS");
      this.commentForm.controls["headerText"].setValue("Confirmed");

    }
    else if (this.selectedAppStatus.attributeName.toUpperCase() == "CANCELLED") {
      this.commentForm.controls["titleA"].setValue("Cancelled by Provider");
      this.commentForm.controls["titleB"].setValue("Cancelled by Patient");
      this.commentForm.controls["headerText"].setValue("Appointment Cancellation");

    }
    else if (this.selectedAppStatus.attributeName.toUpperCase() == "RESCHEDULED") {
      this.commentForm.controls["titleA"].setValue("Rescheduled by Provider");
      this.commentForm.controls["titleB"].setValue("Rescheduled by Patient");
      this.commentForm.controls["headerText"].setValue("Rescheduled");

    }
    else {
      this.commentForm.controls["titleA"].setValue("Confirmed via Phone");
      this.commentForm.controls["titleB"].setValue("Confirmed via SMS");
      this.commentForm.controls["headerText"].setValue(this.selectedAppStatus.attributeName);
    }


  }
  onstatusMenuItemClick(element) {
    this.selectedAppStatus = element;
    this.fnShowSelectedComments();
  }
  OnstatusmenuClick(element) {
    //  this.selectedAppStatus=element;
    // this.fnShowSelectedComments();
  }

  createForm() {
    this.commentForm = this.formBuilder.group({
      comment: ['', [Validators.required]],//, Validators.minLength(6), Validators.maxLength(100)]],
      radtitle: ['1', [Validators.required]],
      titleA: [''],
      titleB: [''],
      headerText: ['']
    });
  }
  changeradiobtn(type) {
    //this.commentForm.controls['radtitle'].setValue(type);

  }
  get formFields() {
    return this.commentForm.controls;
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.commentForm.invalid) {
      return false;
    }
    else {

      this.addCommentstoDB();
    }
  }

  addCommentstoDB() {
    let CommentText = this.formFields.radtitle.value == "1" ? this.formFields.titleA.value.toString() : this.formFields.titleB.value.toString();
    CommentText = CommentText.trim().toLowerCase() + "(" + this.formFields.comment.value.toString().trim().toLowerCase() + ")";
    if (this.postComment.filter(i => i.commentTxt.trim().toLowerCase() == CommentText).length > 0) {
      this._toasterService.error("Status log already added ");
      return false;
    }


    const appointmentLogObj: IAppointmentStatusLogs = {
      appointmentId: this.data.apptData.Id.toString(),
      appStatus: this.selectedAppStatus.attributeId.toString(),
      createdBy: sessionStorage.getItem("userId").toString(),
      reason: this.formFields.radtitle.value == "1" ? this.formFields.titleA.value.toString() : this.formFields.titleB.value.toString(),
      note: this.formFields.comment.value.toString()
    };

    let appointmentLogObjList: IAppointmentStatusLogs[] = [];
    appointmentLogObjList.push(appointmentLogObj);
    this.schedulerservice.AddAppointmentStatusLogs(appointmentLogObjList).subscribe(result => {
      if (result.toLowerCase().indexOf("successfully")) {

        this.getAppointmentLogService_Submit();
        this.commentForm.controls['comment'].setValue("");
        this._toasterService.success(result);

      }
      else
        this._toasterService.error(result);
    })

  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  buttondisable() {
    if (this.commentForm.invalid) {
      this.submitted = true;
    } else {
      this.submitted = false;
    }
  }
}
